import { NgModule } from '@angular/core';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { ManageComponent } from './manage.component';
import { UsersComponent } from './users/users.component';
import { UsersDetailComponent } from './users/users-detail.component';
import { ManageRoutingModule } from './manage-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { CompaniesComponent } from './companies/companies.component';
import { CompaniesFormComponent } from './companies/companies-form.component';
import { CompaniesHistoricalWellsComponent } from './companies/historical-wells/historical-wells.component';
import { CompaniesFracSpreadComponent } from './companies/frac-spread/frac-spread.component';
import { CompaniesEquipmentComponent } from './companies/equipment/equipment.component';
import { ManageUsersService } from './users/manage-users.service';
import { CompaniesHistoricalWellsFormComponent } from './companies/historical-wells/historical-wells-form.component';
import { CompaniesService } from './companies/companies.service';
import { HistoricalWellsTableComponent } from './companies/historical-wells/historical-wells-table.component';
import { FracSpreadComponent } from './frac-spread/frac-spread.component';
import { FracSpreadService } from './frac-spread/frac-spread.service';
import { EquipmentService } from './equipment/equipment.service';
import { EquipmentComponent } from './equipment/equipment.component';
import { HistoricalWellsComponent } from './historical-wells/historical-wells.component';
import { HistoricalWellsService } from './historical-wells/historical-wells.service';

@NgModule({
  declarations: [
    ManageComponent,
    UsersComponent,
    CompaniesComponent,
    CompaniesFormComponent,
    UsersDetailComponent,
    CompaniesHistoricalWellsComponent,
    CompaniesFracSpreadComponent,
    CompaniesEquipmentComponent,
    CompaniesHistoricalWellsFormComponent,
    HistoricalWellsTableComponent,
    FracSpreadComponent,
    EquipmentComponent,
    HistoricalWellsComponent
  ],
  imports: [
    CommonModule,
    ManageRoutingModule,
    Ng2SmartTableModule,
    SharedModule
  ],
  providers: [
    ManageUsersService,
    HistoricalWellsService,
    CompaniesService,
    TitleCasePipe,
    FracSpreadService,
    EquipmentService
  ],
  entryComponents: [UsersDetailComponent, CompaniesHistoricalWellsFormComponent]
})
export class ManageModule { }
